export default __webpack_public_path__ + "static/media/save.f3b96eb5.svg";